import { RasterLayer } from 'mapbox-gl';

import { SPOT_PREDICTION_MINZOOM } from '../../constants/mapLayers/spotPrediction';
import { LayerWithToggleableGroup } from '../../types/types';
import { SOURCE } from '../sources';

export const SPOT_PREDICTION_LAYER: LayerWithToggleableGroup & RasterLayer = {
  id: 'spot_prediction',
  type: 'raster',
  source: SOURCE.spotPrediction.name,
  minzoom: SPOT_PREDICTION_MINZOOM,
  paint: {
    'raster-opacity': 0.7,
    'raster-saturation': 0.9,
    'raster-hue-rotate': 280,
    'raster-contrast': 0.7,
    'raster-brightness-min': 0.25,
    'raster-brightness-max': 0.65,
  },
  layout: {
    visibility: 'visible',
  },
  toggleableGroups: null,
};
